<template>
  <v-layout wrap justify-center>
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <v-flex pl-2 pl-sm-0 sm10 md7 lg7 pt-5 pt-lg-5 style="color: grey">
      Home > <span style="color: black"> Create</span> > Billing Address
    </v-flex> -->
    <v-flex xs12 md6 align-self-center text-center>
      <v-layout wrap justify-center py-5 py-sm-12 py-md-0 py-lg-12>
        <v-flex xs12 sm7 px-2 md10 lg8>
          <v-form ref="form">
            <v-layout wrap>
              <v-flex xs12 style="font: 30px robotomedium" pb-5 pb-lg-12>
                Create Account
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  :rules="[rules.required]"
                  v-model="Fname"
                  label="First Name"
                  class="textfd"
                  outlined
                  dense
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[rules.required]"
                  v-model="Lname"
                  label="Last Name"
                  class="textfd"
                  outlined
                  dense
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[rules.email]"
                  v-model="email"
                  label="Email"
                  class="textfd"
                  outlined
                  dense
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :rules="[rules.required]"
                  v-model="password"
                  label="Password"
                  class="textfd"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  outlined
                  dense
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  @click="uploadData"
                  width="100%"
                  color="#FEBD08"
                  tile
                  style="color: white"
                >
                  CREATE
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      Fname: "",
      Lname: "",
      email: "",
      password: "",
       msg: "",
      timeout: 5000,
      snackbar: false,
      showPassword: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      phnoRules: [
        (v) => !!v || "Phone is required",
        (v) =>
          /[6-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/.test(v) ||
          "Phone is invalid",
      ],
    };
  },
  methods: {
    uploadData() {
      if (this.$refs.form.validate()) {
        axios({
          method: "POST",
          url: "/customer/signup",
          data: {
            firstname: this.Fname,
            lastname: this.Lname,
            email: this.email,
            password: this.password,
          },
        }).then((response) => {
          if (response.data.status) {
            this.msg = "Successfully Registered";
            this.snackbar = true;
            this.$router.push("/login");
          } else {
            this.msg=response.data.msg;
            this.snackbar = true;
          }
        });
      }
    },
  },
};
</script>